// extracted by mini-css-extract-plugin
export default {"cardContent":"cardContent__JiPMG","cardBody":"cardBody"};